import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
## limex.pro IDP

The internal developer portal of Limex: what we build and run, who owns it,
where it runs on Azure, who may touch it, and what it costs.

### Products

- **[QCA](/catalog/default/system/qca)** — QuantCode Automata, the research
  assistant that turns a quant paper into code, runs it and reports back.
- **[QuantX](/catalog/default/system/quantx)** — the MCP marketplace: catalogue,
  API keys, and one public endpoint in front of every MCP server.
- **[QuantLab](/catalog/default/system/quantlab)** — the subscription agent
  workspace for quantitative research.
- **[Internal](/catalog/default/system/internal)** — what the department runs
  for itself: GitLab, Mattermost, this portal, automation, alerting.

Each System page links to the product's environments, repositories and docs.

### What else is here

- **[Software Catalog](/catalog)** — every service, API and Azure resource, with
  its owner, its system and its dependencies.
- **[Azure costs](/azure-costs)** — what each system costs this month, how it
  is trending, and a drill-down to the component, the resource and the Azure
  meter. For the IDP admins.
- **[My Azure access](/azure-access)** — every Azure role you hold, directly or
  through one of your groups.

### Where the data comes from

- **People and teams** — imported from Microsoft Entra ID every hour.
- **Azure resources** — imported from Azure Resource Graph every 30 minutes and
  placed in their system by their \`System\` / \`Component\` tags.
- **Services** — a \`catalog-info.yaml\` in each repository on
  [gitlab.limex.pro](https://gitlab.limex.pro): edit it in git and the change
  shows up here within minutes.

The skeleton to copy, the naming rules for owners and the conventions for
relations are in
[catalog/README.md](https://gitlab.limex.pro/operational/backstage/-/blob/main/catalog/README.md).
If something is missing or stale, the fix is a change to its descriptor — or
to its tags in Azure — rather than a click here.
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'Getting Started',
    description: 'What this portal holds and where its data comes from',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
